export function enableButtonFocusDropper() {
    let mouseDown = false;
    let elements = document.getElementsByClassName("removeFocusFromMouseClick");
    for (let i = 0; i < elements.length; i++) {
        var element = elements[i];
        element.addEventListener('mousedown', () => {
            mouseDown = true;
        });

        element.addEventListener('mouseup', () => {
            mouseDown = false;
        });

        element.addEventListener('focus', (event) => {
            if (mouseDown) {
                event.target.blur();
            }
        });
    }
}